import { render, staticRenderFns } from "./cardMonthDetail.vue?vue&type=template&id=3848f35b&scoped=true"
import script from "./cardMonthDetail.vue?vue&type=script&lang=js"
export * from "./cardMonthDetail.vue?vue&type=script&lang=js"
import style0 from "./cardMonthDetail.vue?vue&type=style&index=0&id=3848f35b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3848f35b",
  null
  
)

export default component.exports